import React, { useEffect, useRef, useState } from "react";
import "./Home.css";
import { useNavigate } from "react-router-dom";

import {
  FaPlay,
  FaShippingFast,
  FaShieldAlt,
  FaUndo,
  FaHeadset,
  FaArrowLeft,
  FaArrowRight,
} from "react-icons/fa";

import { useDispatch, useSelector } from "react-redux";

import { getAllCategories } from "../../features/master/masterSlice";
import { getAllTopProducts } from "../../features/products/productsSlice";
import {
  getCsrBanner,
  getCorporateBanner,
} from "../../features/home/homeSlice";

import New_arrival_card from "./top-frames/New_arrival_card";
import Brands from "./brands/Brands";
import Offer_banner from "./offer-banner/Offer_banner";

import "./new-arrivals-section.css";

/* ==========================================================
   USP ITEMS
   ========================================================== */

{
  /*const USP_ITEMS = [
  {
    icon: <FaShieldAlt />,
    text: "100% Authentic Products",
  },
  {
    icon: <FaShippingFast />,
    text: "Free Shipping Above ₹999",
  },
  {
    icon: <FaUndo />,
    text: "Easy 7-Day Returns",
  },
  {
    icon: <FaHeadset />,
    text: "Expert Support",
  },
]; */
}

const ARRIVALS_VISIBLE = 3;

/* ==========================================================
   HOME COMPONENT
   ========================================================== */

function Home({ handleFilterChange }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const categories = useSelector((state) => state.master.categories);

  const topProducts = useSelector((state) => state.product.allProductsTop);

  const csrBanner = useSelector((state) => state.home.csrBanner);

  const corporateBanner = useSelector((state) => state.home.corporateBanner);

  useEffect(() => {
    dispatch(getAllCategories());
    dispatch(getAllTopProducts({}));
    dispatch(getCsrBanner({ banner_type_id: 4 }));
    dispatch(getCorporateBanner({ banner_type_id: 5 }));
  }, [dispatch]);

  const handleCategoryClick = (category) => {
    if (!handleFilterChange) return;

    handleFilterChange("category", {
      id: category.id,
      name: category.name,
    });

    navigate("/all-products");
  };

  /* ----------------------------------------------------------
     First four categories
     ---------------------------------------------------------- */

  const categoryCards =
    categories && categories.length > 0 ? categories.slice(0, 4) : [];

  /* ----------------------------------------------------------
     Try-on selected product
     ---------------------------------------------------------- */

  const [, setSelectedProduct] = useState(null);

  /* ----------------------------------------------------------
     New Arrivals - strict 3-at-a-time window. Clicking the next
     arrow shifts the window forward by one product (so the 1st
     card drops off, 2nd takes its spot, 3rd takes the 2nd's spot,
     and one new card slides into the 3rd spot) rather than free
     scrolling the whole row.
     ---------------------------------------------------------- */

  const [arrivalsStart, setArrivalsStart] = useState(0);
  const maxArrivalsStart = Math.max((topProducts?.length || 0) - ARRIVALS_VISIBLE, 0);

  const visibleArrivals =
    topProducts?.slice(arrivalsStart, arrivalsStart + ARRIVALS_VISIBLE) || [];

  const shiftArrivals = (direction) => {
    setArrivalsStart((current) => {
      const next = current + direction;
      if (next < 0) return 0;
      if (next > maxArrivalsStart) return maxArrivalsStart;
      return next;
    });
  };

  const videoCards = [csrBanner, corporateBanner]
    .filter((b) => b && b.image)
    .map((b) => ({
      title: b.name,
      src: process.env.REACT_APP_IMAGE_URL + b.image,
    }));

  return (
    <>
      <Brands variant="single" showTitle={false} />

      <Offer_banner />

      {/* ======================================================
          USP BAR
          ====================================================== */}

      {/*  <section className="usp_sec">
        <div className="container-xl usp_grid">

          {USP_ITEMS.map((item) => (
            <div
              className="usp_item"
              key={item.text}
            >
              <span className="usp_icon">
                {item.icon}
              </span>

              <span className="usp_text">
                {item.text}
              </span>
            </div>
          ))}

        </div>
      </section> */}

      {/* ======================================================
          NEW ARRIVALS - shows ARRIVALS_VISIBLE (3) cards at a time
          ====================================================== */}

      {topProducts?.length > 0 && (
        <section className="new_arrivals_sec">
          <div className="container-xl">
            <div className="new_arrivals_header">
              <h2 className="new_arrivals_title">
                Shop by{" "}
                <span className="new_arrivals_title_accent">new arrivals</span>
              </h2>
            </div>
          </div>

          <div className="new_arrivals_carousel">
            <button
              type="button"
              className="nav_side_arrow nav_side_arrow_left"
              onClick={() => shiftArrivals(-1)}
              disabled={arrivalsStart <= 0}
              aria-label="Show previous new arrivals"
            >
              <FaArrowLeft />
            </button>

            <div className="container-xl">
              <div className="new_arrivals_grid">
                {visibleArrivals.map((product) => (
                  <div className="new_arrivals_item" key={product.id}>
                    <New_arrival_card
                      {...product}
                      setSelectedProduct={() => setSelectedProduct(product)}
                    />
                  </div>
                ))}
              </div>
            </div>

            <button
              type="button"
              className="nav_side_arrow nav_side_arrow_right"
              onClick={() => shiftArrivals(1)}
              disabled={arrivalsStart >= maxArrivalsStart}
              aria-label="Show next new arrivals"
            >
              <FaArrowRight />
            </button>
          </div>
        </section>
      )}

      {/* ======================================================
          CATEGORY CARDS
          ====================================================== */}

      <section className="category_cards_sec">
        <div className="container-xl">
          <div className="category_cards_grid">
            {categoryCards.length > 0 ? (
              categoryCards.map((category) => (
                <div
                  className="category_card"
                  key={category.id}
                  onClick={() => handleCategoryClick(category)}
                >
                  <img
                    className="category_card_img"
                    src={process.env.REACT_APP_IMAGE_URL + category.image}
                    alt={category.name || "Category"}
                  />

                  <p className="category_card_label">{category.name}</p>
                </div>
              ))
            ) : (
              <div className="no-data">No categories yet</div>
            )}
          </div>
        </div>
      </section>

      {/* ======================================================
          TWO SIDE-BY-SIDE PROMOTIONAL VIDEOS 
          ====================================================== */}

      {videoCards.length > 0 && (
        <section className="video_cards_sec">
          <div className="video_cards_grid">
            {videoCards.map((card) => (
              <VideoCard card={card} key={card.title} />
            ))}
          </div>
        </section>
      )}
    </>
  );
}

/* ==========================================================
   VIDEO CARD - silent autoplay/loop, matching the hero video
   ========================================================== */

const VideoCard = ({ card }) => {
  return (
    <div className="video_card">
      <video
        className="video_card_media"
        src={card.src}
        autoPlay
        muted
        loop
        playsInline
      />
      {card.title && <p className="video_card_title">{card.title}</p>}
    </div>
  );
};

export default Home;